import { Button, Card, Image } from "antd";
import activitylog from "assets/activitylog.svg";
import dayjs from "dayjs";
import { useState } from "react";

export const ActivityLogView = ({ activitylogdata, isLoading }: any) => {
  const [expandedIndexes, setExpandedIndexes] = useState<{ [key: number]: boolean }>({});
  const toggleExpand = (index: number) =>
    setExpandedIndexes((prev) => ({ ...prev, [index]: !prev[index] }));
  
return (
    <Card title="Activity Log" style={{ borderRadius: 12 }} loading={isLoading}>
      <div className="relative flex flex-col items-start">
        {activitylogdata?.map((item: any, index: number) => {
          const isExpanded = expandedIndexes[index] || false;
          const images = isExpanded ? item.vImage : item.vImage?.slice(0, 6);

          return (
            <div key={index} className="flex items-start relative w-full mb-6">
              {index !== activitylogdata.length - 1 && (
                <div className="absolute left-5 top-10 w-[2px] bg-gray-300 h-full" />
              )}
              {/* Timeline Icon */}
              <div className="flex flex-col items-center mr-4">
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full border-2 shadow-sm ${item.actionType
                      ? "bg-green-500 border-green-500 text-white"
                      : "bg-white border-gray-400 text-gray-500"
                    }`}
                >
                  <img src={activitylog} alt="log-icon" className="w-5 h-5" />
                </div>
              </div>

              {/* Log Content */}
              <div className="flex flex-col p-4 rounded-lg shadow-md flex-1 bg-white">
                <h3 className="font-semibold text-gray-800 mb-1">{item.actionType}</h3>
                {item.transactionRemark && (
                  <div className="mb-3 px-3 py-2 border border-gray-200 rounded-lg bg-gray-100 text-sm text-gray-700">
                    {item.transactionRemark}
                  </div>
                )}

                <span className="text-xs text-gray-500 mb-2">
                  {dayjs(item.createdOn).format("DD-MMM-YYYY hh:mm A")}
                </span>

                { (item.stationName!=null)?(
                   <span className="text-xs text-gray-500 mb-2">
                  {item.stationName}
                </span>
                ):null }
               
                {item.isAccountApproved!=null && item.isAccountApproved!="" && item.actionType=='Exit'?(
                   <span className="text-xs text-gray-500 mb-2">
                 Exit Gate Status : {item.isAccountApproved}
                </span>

                ):null}

                {(item.weight!=null && item.actionType=="Weight")?(
                  <>
                  <span className="text-xs text-gray-500 mb-2">
                  {item.weight} kg
                </span>
                  </>
                ):null}
                

                {item?.vImage?.length > 0 && (
                  <>
                    <div className="grid grid-cols-4 sm:grid-cols-8  gap-3 mt-2">
                      {images.map((img: any, idx: number) => (
                        <div
                          key={idx}
                          className="overflow-hidden rounded-lg border border-gray-200 shadow-sm"
                        >
                          <Image
                            src={img?.image}
                            alt={img?.name || `image-${idx}`}
                            width={40}
                            height={40}
                            style={{ objectFit: "cover", width: "100%", height: "100%" }}
                          />
                        </div>
                      ))}
                    </div>

                    {item.vImage.length > 6 && (
                      <Button type="link" onClick={() => toggleExpand(index)} className="mt-2 px-0">
                        {isExpanded ? "Show Less" : "Show More"}
                      </Button>
                    )}
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};
